
import { Options, Vue } from "vue-class-component";
import { compare, getLocalProject, isJsonString, unique_json } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchGetPerformanceAnalysis,
  dispatchGetPerformanceSelectOptions,
} from "@/store/performance/actions";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { store } from "@/store";
import {
  readPerformanceAnalysis,
  readPerformanceSelectOptions,
} from "@/store/performance/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import { readProjectDetail, readProjectScenes } from "@/store/project/getters";
@Options({
  components: {
    SideMenu,
  },
})
export default class PerformanceAnalysis extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  //选择场景
  public selected_table_scene = "";
  // 选择机型
  public selected_table_device = "";
  // 选择版本
  public selected_table_version = "";
  public loading = false;
  public echartTitle = "平均FPS"; //趋势图标题
  // 中文名
  public fields = {
    avg_fps: "平均FPS", // 平均FPS
    max_pss: "峰值PSS", // 峰值PSS
    max_mono_used: "maxMonoUsed(M)", // 峰值Used Mono
    max_mono_total: "峰值mono内存(M)", // 峰值Total Mono
    avg_cpu: "平均CPU", // 平均CPU
    fps_lt_10_pcnt: "FPS<10占⽐(%)", // FPS<=10占有率(%)
    fps_lt_18_pcnt: "FPS>18占⽐(%)", // FPS>=18占有率(%)
    fps_lt_25_pcnt: "FPS>25占⽐(%)", // FPS>=25占有率(%)
    fps_lt_40_pcnt: "FPS>40占⽐(%)", // FPS>=40占有率(%)
    cpu_lt_60_pcnt: "FPS<60占⽐(%)", // FPS<=60占有率(%)
    cpu_lt_80_pcnt: "FPS<80占⽐(%)", // FPS<=80占有率(%)
    dps: "dps",
    avg_dc: "平均DC", // 平均DC
    max_dc: "峰值DrawCall数", // 峰值DC
    max_triangle: "峰值三角形数", // 峰值三角形(万)
    duration: "耗时", // 耗时
    avg_flow: "流量(KB/S)", // 流量(KB/S)
    max_swap: "maxSwap",
    max_vss: "maxVss(MB)",
    max_swap_add_pss: "maxSwapAddPss",
    process_up_flow: "进程上行流量[KB/s]",
    process_down_flow: "进程下行流量[KB/s]",
    logic_up_flow: "逻辑上行流量[KB/s]",
    logic_down_flow: "逻辑下行流量[KB/s]",
    lag_cnt: "卡顿次数", // 卡顿次数
    single_peak_lag_cnt: "singlePeakLagCnt",
    multiple_peak_lag_cnt: "multiplePeakLagCnt",
    continue_low_lag_cnt: "continueLowLagCnt",
    lag_pcnt: "卡顿率", // 卡顿率
    lag_freq: "卡顿频率",
    id_row_start: "id_row_start",
    id_row_end: "id_row_end",
    id_frame_start: "id_frame_start",
    id_frame_end: "id_frame_end",
    avg_cpu_total: "avgCpuTotal",
    gc_cnt: "GC(次)", // gc_cnt
    gc_freq: "GC频率",
    cpu_power: "CPU功耗", // 平均FPS
    max_cpu_usage: "MAX(单核使用率)", // 峰值PSS
    avg_cpu_usage: "AVG(使用率)", // 峰值Used Mono
    max_cpu_freq: "MAX(单核频率)", // 峰值Total Mono
    avg_cpu_freq: "AVG(单核频率)", // 峰值Total Mono
  };
  public customizedName = [
    "cpu_power",
    "max_cpu_usage",
    "avg_cpu_usage",
    "max_cpu_freq",
    "avg_cpu_freq",
  ];

  public resArray = [undefined, NaN];
  // 性能趋势
  public async mounted() {
    this.loading = true;
    await dispatchGetPerformanceSelectOptions(store, {
      project: this.localProject,
    });
    await dispatchGetProjectScenes(store, { project: this.localProject });
    await dispatchGetDeviceSpecs(store, { project: this.localProject });
    this.selected_table_scene = this.scene_options.map(
      (item) => item.scene_id
    )[0];
    this.selected_table_device = this.all_device_options.map(
      (item: any) => item.value
    )[0];
    this.selected_table_version = this.game_version_options.map(
      (item: any) => item.value
    )[0];
    await dispatchGetPerformanceAnalysis(store, {
      project: this.localProject,
      game_version: this.resArray.includes(this.selected_table_version as any)
        ? 0
        : this.selected_table_version,
      scene_id: this.resArray.includes(this.selected_table_scene as any)
        ? 0
        : Number(this.selected_table_scene),
      device_id: this.resArray.includes(this.selected_table_device as any)
        ? 0
        : this.selected_table_device,
    });
    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    await this.trendChart2("avg_fps", "平均FPS");
    await this.comparePerformanceAnalysis;

    await this.performanceTrends_echarts;
    await this.tabValues;
    if (this.localProject !== 7) {
      let deleteCard = document.getElementById("delete");

      deleteCard?.removeChild(deleteCard.children[5]);

      deleteCard?.removeChild(deleteCard.children[4]);
    }

    this.loading = false;
  }
  // 场景
  public get getScenes() {
    const scenes = readProjectScenes(store);
    return scenes;
  }
  public get getPerformanceSelectOptions() {
    return readPerformanceSelectOptions(store);
  }
  // 机型
  public get getDeviceSpecs() {
    const devices = readDeviceSpecs(store);
    return devices;
  }
  // 性能概况
  public get PerformanceAnalysis() {
    return readPerformanceAnalysis(store);
  }
  // 选择场景
  public get scene_options() {
    const scene_list: any[] = this.getPerformanceSelectOptions.scene_list;
    scene_list.forEach((scene) => {
      let chinese = this.getScenes.filter(
        (item: any) => item.id === Number(scene.scene_id)
      )[0]?.chinese;
      scene.chinese = chinese;
    });
    return scene_list.sort(compare("count"));
  }

  // 获取机型
  public get all_device_options() {
    const devices = this.getPerformanceSelectOptions.device_list;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device: any) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
      });
    });
    return device_select;
  }

  // 机型分类
  public get device_options() {
    const devices = this.getPerformanceSelectOptions.device_list;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest.sort(compare("level"));
  }
  // 版本
  public get game_version_options() {
    const versions = this.getPerformanceSelectOptions.game_versions;
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item) {
        game_version_select.push({
          label: item,
          value: item,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return unique_json(game_version_select, "value");
  }

  // 重置
  public async onTableClear() {
    this.loading = true;
    this.selected_table_scene = this.scene_options.map(
      (item) => item.scene_id
    )[0];
    this.selected_table_device = this.all_device_options.map(
      (item: any) => item.value
    )[0];
    this.selected_table_version = this.game_version_options.map(
      (item: any) => item.value
    )[0];
    await dispatchGetPerformanceAnalysis(store, {
      project: this.localProject,
      game_version: this.selected_table_version,
      scene_id: Number(this.selected_table_scene),
      device_id: this.selected_table_device,
    });
    await this.comparePerformanceAnalysis;
    await this.trendChart2("avg_fps", "平均FPS");
    await this.performanceTrends_echarts;
    await this.tabValues;
    this.loading = false;
  }
  // 切换时触发
  public async selectTableChange() {
    this.loading = true;
    await dispatchGetPerformanceAnalysis(store, {
      project: this.localProject,
      game_version: this.selected_table_version,
      scene_id: Number(this.selected_table_scene),
      device_id: this.selected_table_device,
    });
    await this.trendChart2("avg_fps", "平均FPS");
    this.loading = false;
  }

  // 展示重要的数据指标的比较
  public get comparePerformanceAnalysis() {
    const FPS1 = this.PerformanceAnalysis.current_version_data.avg_fps;
    const FPS2 = this.PerformanceAnalysis.last_version_data.avg_fps;
    const lagPcnt1 = this.PerformanceAnalysis.current_version_data.lag_pcnt;
    const lagPcnt2 = this.PerformanceAnalysis.last_version_data.lag_pcnt;
    const maxPss1 = this.PerformanceAnalysis.current_version_data.max_pss;
    const maxPss2 = this.PerformanceAnalysis.last_version_data.max_pss;
    const maxMonoUsed1 = this.PerformanceAnalysis.current_version_data
      .max_mono_used;
    const maxMonoUsed2 = this.PerformanceAnalysis.last_version_data
      .max_mono_used;
    const avgCpu = this.PerformanceAnalysis.current_version_data.avg_cpu_usage
      ? this.PerformanceAnalysis.current_version_data.avg_cpu_usage
      : 0;
    const avgCpu2 = this.PerformanceAnalysis.last_version_data.avg_cpu_usage
      ? this.PerformanceAnalysis.last_version_data.avg_cpu_usage
      : 0;
    const cpu_power = this.PerformanceAnalysis.current_version_data.cpu_power
      ? this.PerformanceAnalysis.current_version_data.cpu_power
      : 0;
    const cpu_power1 = this.PerformanceAnalysis.last_version_data.cpu_power
      ? this.PerformanceAnalysis.last_version_data
      : 0;

    const compare = {
      avg_fps: {
        value: FPS1,
        result: this.compareVal(FPS1, FPS2),
        label: "平均FPS",
      },
      lag_pcnt: {
        value: Number(lagPcnt1).toFixed(1) ? lagPcnt1 : 0 + "%",
        result: this.compareVal(lagPcnt1, lagPcnt2).toFixed(2),
        label: "卡顿率",
      },
      max_pss: {
        value: maxPss1 + "MB",
        result: this.compareVal(maxPss1, maxPss2),
        label: "最高内存",
      },
      max_mono_used: {
        value: maxMonoUsed1 ? maxMonoUsed1 : 0 + "MB",
        result: this.compareVal(maxMonoUsed1, maxMonoUsed2)
          ? this.compareVal(maxMonoUsed1, maxMonoUsed2)
          : 0,
        label: "mono堆内存",
      },
      cpu_average: {
        value: avgCpu + "%",
        result: this.compareVal(avgCpu, avgCpu2),
        label: "avg CPU占用率",
      },
      cpu_power: {
        value: cpu_power,
        result: this.compareVal(cpu_power, cpu_power1)
          ? this.compareVal(cpu_power, cpu_power1)
          : 0,
        label: "CPU功耗",
      },
    };

    return compare;
  }

  public compareVal(val1: any, val2: any) {
    return Number((Number(val1) - Number(val2)).toFixed(2));
  }

  // 关键性能数据处理
  public get keyPerformanceData() {
    const key = this.PerformanceAnalysis.current_version_data;
    const keyVal = [
      {
        lable: "平均FPS",
        value:
          key.avg_fps === "" || key.avg_fps === undefined ? "--" : key.avg_fps,
        key: "avg_fps",
      },
      {
        lable: "卡顿率",
        value:
          (!key.lag_pcnt || key.lag_pcnt === null || key.lag_pcnt === undefined
            ? "--"
            : Number(key.lag_pcnt).toFixed(1)) + "%",
        key: "lag_pcnt",
      },
      {
        lable: "最高内存",
        value:
          key.max_pss === "" || key.max_pss === undefined || !key.max_pss
            ? "--"
            : key.max_pss + "MB",
        key: "max_pss",
      },
      {
        lable: "mono堆内存",
        value:
          (key.max_mono_used === "" ||
          key.max_mono_used === undefined ||
          !key.max_mono_used
            ? "--"
            : key.max_mono_used) + "MB",
        key: "max_mono_used",
      },
      {
        lable: "CPU占比",
        value:
          (key.avg_cpu / 100 === null || key.avg_cpu / 100 === undefined
            ? "--"
            : (key.avg_cpu / 100).toFixed(2)) + "%",
        key: "avg_cpu",
      },
      {
        lable: "GC次数",
        value:
          key.gc_cnt === null || key.gc_cnt === undefined ? "--" : key.gc_cnt,
        key: "gc_cnt",
      },
      {
        lable: "三角形数",
        value:
          (key.max_triangle === "" || key.max_triangle === null
            ? "--"
            : key.max_triangle) + "万",
        key: "max_triangle",
      },
      {
        lable: "峰值DrawCall数",
        value:
          (key.max_dc === "" || key.max_dc === null ? "--" : key.max_dc) + "万",
        key: "max_dc",
      },
      {
        lable: "平均CPU",
        value:
          key.avg_cpu_usage === null || key.avg_cpu_usage === ""
            ? "--"
            : key.avg_cpu_usage,
        key: "avg_cpu_usage",
      },
      {
        lable: "最大CPU",
        value:
          key.max_cpu_usage === "" || key.max_cpu_usage === null
            ? "--"
            : key.max_cpu_usage,
        key: "max_cpu_usage",
      },
      {
        lable: "CPU功耗",
        value:
          key.cpu_power === null || key.cpu_power === null
            ? "--"
            : key.cpu_power,
        key: "cpu_power",
      },
    ];
    if (this.localProject !== 7) {
      console.log(keyVal.splice(8));
    }
    return keyVal;
  }

  public trendChart2Val: any = { xValue: [], yValue: [] }; //性能趋势数据预处理
  public trendChart2(val: any, title: string) {
    const yValue2: any = [];
    const xValue2: any = [];
    this.PerformanceAnalysis.nearby_seven_data.forEach((item: any) => {
      this.PerformanceAnalysis.version_list.forEach((item2: any) => {
        if (item.game_version === item2) {
          yValue2.push(item[val]);
          xValue2.push(item.game_version);
        }
      });
    });
    this.trendChart2Val = {
      xValue: xValue2,
      yValue: yValue2,
    };
    this.echartTitle = title;
    this.performanceTrends_echarts;
  }

  // 使用echarts---性能趋势
  public get performanceTrends_echarts() {
    let performanceTrends: any = document.getElementById("performanceTrends");
    echarts.dispose(performanceTrends);
    let PerformanceLineChart = echarts.init(performanceTrends);
    var dataAxis = this.trendChart2Val.xValue;
    var data = this.trendChart2Val.yValue;
    let option;
    option = {
      grid: {
        left: 50,
        bottom: 40,
        right: 20,
        top: 30,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          magicType: { show: true, type: ["line", "bar"] },
        },
      },
      tooltip: {
        trigger: "axis",
      },
      xAxis: {
        data: dataAxis,
        axisLabel: {
          textStyle: {
            color: "#999",
            padding: [10, 0, 0, 0],
          },
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        z: 10,
      },
      yAxis: {
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: "#999",
          },
        },
      },
      dataZoom: [
        {
          type: "inside",
        },
      ],
      series: [
        {
          type: "bar",
          showBackground: true,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#83bff6" },
              { offset: 0.5, color: "#188df0" },
              { offset: 1, color: "#188df0" },
            ]),
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#2378f7" },
                { offset: 0.7, color: "#2378f7" },
                { offset: 1, color: "#83bff6" },
              ]),
            },
          },
          data: data,
        },
      ],
    };
    var zoomSize = 6;
    PerformanceLineChart.on("click", function (params) {
      PerformanceLineChart.dispatchAction({
        type: "dataZoom",
        startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
        endValue:
          dataAxis[Math.min(params.dataIndex + zoomSize / 2, data.length - 1)],
      });
    });
    PerformanceLineChart.setOption(option);
    return PerformanceLineChart;
  }
  // 指标分类
  public basic: any = [];
  public advance: any = [];
  public customize: any = [];
  public get tabValues() {
    let project = readProjectDetail(store);
    let allIndex: any =
      project.report_settings !== null && isJsonString(project.report_settings)
        ? JSON.parse(project.report_settings as string).content.index_type
        : {};
    let basic: any[] = allIndex.basic; //基础指标
    let advance: any[] = allIndex.advance; //深度指标
    let customize: any[] = allIndex.customize;
    let addcustomize = this.PerformanceAnalysis.custom_index;
    if (addcustomize.length !== 0) {
      customize.push(...addcustomize);
    }
    let endcustomize: any[] = Array.from(new Set(customize)); //定制指标
    this.basic = basic;
    this.advance = advance;
    this.customize = endcustomize;

    return allIndex;
  }

  // 合并单元行
  public dataDetailsSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (
      rowIndex === 0 ||
      rowIndex === Number(this.basic.length + 1) ||
      rowIndex === Number(this.basic.length + this.advance.length + 2) ||
      rowIndex ===
        Number(
          this.basic.length + this.advance.length + this.customize.length + 3
        )
    ) {
      return {
        rowspan: 1, // 合并行数
        colspan: 7, // 合并列数
      };
    }
  }
}
